/**
 * @format
 */

import ChartPieSlice from 'img/ChartPieSlice.png';
import ChartPieFilled from 'img/ChartPieFilled.png';
import ChartBar from 'img/ChartBar.png';
import ChartBarFilled from 'img/ChartBarFilled.png';
import Trophy from 'img/Trophy.png';
import TrophyFilled from 'img/TrophyFilled.png';
import Building from 'img/Buildings.png';
import BuildingFilled from 'img/BuildingsFilled.png';
import Textbox from 'img/Textbox.png';
import TexboxFilled from 'img/TextboxFilled.png';
import UsersThree from 'img/UsersThree.svg';
import UserThreeFilled from 'img/UsersThreeFilled.svg';
import Headset from 'img/Headset.svg';
import HeasetFilled from 'img/HeadsetFilled.svg';
import Globe from 'img/globe.svg';
import GlobFilled from 'img/globeFilled.svg';
import Customer from 'img/Customer.svg';
import CustomerFilled from 'img/customerFilledsvg.svg';

import { MenuSection } from '../types/menu.types';

/**
 * All available menu items
 */
const ALL_MENU_ITEMS = {
  dashboard: {
    id: 'dashboard',
    label: 'Dashboard',
    path: '/dashboard',
    icon: ChartPieSlice,
    iconFilled: ChartPieFilled,
    category: 'analytics' as const,
  },
  affiliatesPerformance: {
    id: 'affiliates-performance',
    label: 'Affiliate Performance',
    path: '/affiliates-performance',
    icon: ChartBar,
    iconFilled: ChartBarFilled,
    category: 'analytics' as const,
  },
  leaderboard: {
    id: 'leaderboard',
    label: 'Agent Leaderboard',
    path: '/leaderboard',
    icon: Trophy,
    iconFilled: TrophyFilled,
    category: 'analytics' as const,
  },
  campaign: {
    id: 'campaign',
    label: 'Campaign Overview',
    path: '/campaign',
    icon: Headset,
    iconFilled: HeasetFilled,
    category: 'analytics' as const,
  },
  vendors: {
    id: 'vendors',
    label: 'Global Performance',
    path: '/vendors',
    icon: Globe,
    iconFilled: GlobFilled,
    category: 'analytics' as const,
  },
  offices: {
    id: 'offices',
    label: 'Affiliate Offices',
    path: '/offices',
    icon: Building,
    iconFilled: BuildingFilled,
    category: 'management' as const,
  },
  forms: {
    id: 'forms',
    label: 'Forms',
    path: '/forms',
    icon: Textbox,
    iconFilled: TexboxFilled,
    category: 'management' as const,
  },
  customers: {
    id: 'customers',
    label: 'Customer Directory',
    shortLabel: 'Customers',
    path: '/customers',
    icon: Customer,
    iconFilled: CustomerFilled,
    category: 'management' as const,
  },
  users: {
    id: 'users',
    label: 'Users',
    path: '/users',
    icon: UsersThree,
    iconFilled: UserThreeFilled,
    category: 'management' as const,
  },
};

/**
 * Role-based menu access
 * Can be overridden by user access permissions
 */
const ROLE_MENU_ACCESS: Record<string, string[]> = {
  root_user: [
    'dashboard',
    'affiliates-performance',
    'leaderboard',
    'campaign',
    'vendors',
    'forms',
    'customers',
   
  ],
  admin: [
    'dashboard',
    'leaderboard',
    'forms',
    'customers',
     'vendors', 
    'campaign',
    'users',
    // 'affiliates-performance' - conditionally added if downlineAccess is true
    // 'offices' - conditionally added if downlineAccess is true
  ],
  agent: ['dashboard', 'leaderboard', 'forms'],
  custo: [
    'forms',
    'customers', ],

  root_custo: [
    'forms',
    'customers'],
};


export interface UserAccessInfo {
  downlineAccess?: boolean;
  snsAccess?: boolean;
}

/**
 * Get menu sections based on user role and access permissions
 */
export const getMenuSectionsByRole = (
  role?: string,
  userAccess?: UserAccessInfo
): MenuSection[] => {
  let allowedMenuIds = [...(ROLE_MENU_ACCESS[role || 'agent'] || ROLE_MENU_ACCESS.agent)];

  // Apply dynamic access control for admin role
  if (role === 'admin' && userAccess?.downlineAccess) {
    // Admin with downlineAccess can see affiliates-performance and offices
    if (!allowedMenuIds.includes('affiliates-performance')) {
      allowedMenuIds.push('affiliates-performance');
    }
   
  }

  const sections: MenuSection[] = [];

  // Analytics section
  const analyticsItems = [
    ALL_MENU_ITEMS.dashboard,
    ALL_MENU_ITEMS.affiliatesPerformance,
    ALL_MENU_ITEMS.leaderboard,
    ALL_MENU_ITEMS.campaign,
    ALL_MENU_ITEMS.vendors,
  ].filter((item) => allowedMenuIds.includes(item.id));

  if (analyticsItems.length > 0) {
    sections.push({
      category: 'analytics',
      title: 'Analytics',
      shortTitle: 'Ana...',
      items: analyticsItems,
    });
  }

  // Management section
  const managementItems = [
    ALL_MENU_ITEMS.offices,
    // Change forms path for agent role
    role === 'agent' 
      ? { ...ALL_MENU_ITEMS.forms, path: '/agent/forms' }
      : ALL_MENU_ITEMS.forms,
    ALL_MENU_ITEMS.customers,
    ALL_MENU_ITEMS.users,
  ].filter((item) => allowedMenuIds.includes(item.id));

  if (managementItems.length > 0) {
    sections.push({
      category: 'management',
      title: 'Management',
      shortTitle: 'Mana...',
      items: managementItems,
    });
  }

  return sections;
};

